/* Bigalli · Línea Frontier
   1) Reveal al hacer scroll (fallback para navegadores sin animation-timeline)
   2) Ritmo del lookbook: asigna el modificador de proporción por posición
   Idempotente y compatible con las recargas del editor de temas. */

(function () {
  'use strict';

  /* ---------- Reveal fallback ---------- */
  function initReveal(scope) {
    var supportsTimeline = CSS && CSS.supports && CSS.supports('animation-timeline', 'view()');
    if (supportsTimeline) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var nodes = (scope || document).querySelectorAll('.bf-reveal:not([data-bf-revealed])');
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.setAttribute('data-bf-revealed', 'true'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        el.setAttribute('data-bf-revealed', 'true');
        el.style.animation = 'bfRevealUp .7s ease both';
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.05 });

    nodes.forEach(function (n) {
      n.style.opacity = '0';
      n.style.willChange = 'opacity, transform';
      n.addEventListener('animationend', function () {
        n.style.opacity = '';
        n.style.willChange = '';
      }, { once: true });
      io.observe(n);
    });
  }

  /* ---------- Ritmo del lookbook ---------- */
  /* Patrón por fila: alto, alto, cuadrado → evita una parrilla monótona
     sin que el comerciante tenga que elegir proporción por bloque. */
  function initLookbookRhythm(grid) {
    if (!grid || grid.dataset.bfRhythmReady === 'true') return;
    if (grid.getAttribute('data-bf-rhythm') !== 'auto') return;
    grid.dataset.bfRhythmReady = 'true';

    var tiles = grid.querySelectorAll('.bf-look__tile');
    tiles.forEach(function (tile, i) {
      tile.classList.remove('bf-look__tile--square', 'bf-look__tile--wide');
      if (i % 3 === 2) tile.classList.add('bf-look__tile--square');
    });
  }

  function boot(scope) {
    initReveal(scope);
    (scope || document).querySelectorAll('[data-bf-rhythm]').forEach(initLookbookRhythm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
